import React from "react";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import { Button, Tooltip } from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomizedDialogs(props) {
  let { endDate, endTime, startDate, startTime, dependson, labType } = props;

  function DateTime2(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: timezone,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace(/\//g, "-");
    const endDate3 = endDatef.replace(/\//g, "-");
    return endDate3;
  }

  function timeDiff(endDate, endTime, startDate, start_time, dependson) {

    function parseDate(str) {
      const [day, month, year] = str.split("-");
      return new Date(year, month - 1, day); // month is 0-based
    }
    
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    const currentTime = new Date().toLocaleString('en-GB', { timeZone: `${timezone}` });
    const currentTime1 = currentTime.split(",");
    const formattedTime = currentTime1[1].substring(0, 6);
    const endTimeMoment = moment(endTime3, 'HH:mm');
    const formattedTimeMoment = moment(formattedTime, 'HH:mm');
    
    let disableButton = true;
    const diffInMinutes = endTimeMoment.diff(formattedTimeMoment, 'minutes');

    const now = new Date();
    const currentDate_now = moment(now).format('DD-MM-YYYY');

    const startUTC = new Date(startDate + "T" + start_time + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startDate2 = startUTC.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-"); // get the lab Start Date part only

    const endUTC = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endUTC.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-"); // get the end Date part only

    // get parsing Dates
    const startDate_parse = parseDate(startDate3); // get parsing lab start date
    const endDate_parse = parseDate(endDate3); // get parsing lab end date
    const currentDate_parse = parseDate(currentDate_now); // get parsing current date

    const isWithinDateRange = currentDate_parse >= startDate_parse && currentDate_parse <= endDate_parse;
    const env_diffMinutes = (process.env.REACT_APP_DIFFENDTIME || 0); // REACT_APP_DIFFENDTIME

    if (dependson === "immediate" || dependson === "always") {
      const endUtc = new Date(`${endDate}T${endTime}:00Z`);
      const totalMinutesRemaining = Math.floor((endUtc - now) / (1000 * 60));
      
      if (isWithinDateRange) {
        if (totalMinutesRemaining > env_diffMinutes) {
          disableButton = false;
        }
      }
    }
    else {
      disableButton = diffInMinutes <= env_diffMinutes && diffInMinutes >= 0;
    }

    return disableButton;
  }

  const [open, setOpen] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to stop a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    let api_call = ""
    const InstanceID = localStorage.getItem("InstanceID");
    if (labType === "pc") {
      api_call = `${process.env.REACT_APP_API_URL}/api/stoppreconfiguredlab/${InstanceID}`
    }
    else if (labType === "custom") {
      api_call = `${process.env.REACT_APP_API_URL}/api/stoplab/${InstanceID}`
    }
    else if (labType === "hvm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/stophvmclab/${InstanceID}`
    }
    else if (labType === "svm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/stopsvmlab/${InstanceID}`
    }
    else if (labType === "wise") {
      api_call = `${process.env.REACT_APP_API_URL}/api/stopwiselab/${InstanceID}`
    }
    
    fetch(api_call, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data === "Success") {
            setOpen(false);
            window.location.reload();
          }
          else {
            setOpen(true);
            setOpentitle(data);
          }
        } else {
          if (data.name) {
            setOpen(false);
            setState({ errorMessage: data.name[0] });
          }
        }
      })
      .catch((error) => {
        setOpen(false);
        window.location.reload();
      });
  };

  return (
    <div>
      <Dialog
          open={popupopen}
          onClose={handlePopUpClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {popupopentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handlePopUpClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmitClick} color="primary">
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Tooltip
          title={
            timeDiff(endDate, endTime, startDate, startTime, dependson, labType)
              ? "You can't stop this lab yet"
              : "Stop"
          }
          arrow
        >
          <span> {/* Wrapping span allows tooltip even when button is disabled */}
            <Button
              sx={{
                mx: 0.5,
                height: { xs: "26px", sm: "30px" },
                width: { xs: "26px", sm: "30px" },
                minWidth: "auto",
                marginBottom: { xs: "3px", sm: "5px" },
                marginTop: { xs: "-18px", sm: "-20px" },
                borderRadius: "50px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                p: 0,
              }}
              variant="contained"
              disabled={timeDiff(endDate, endTime, startDate, startTime, dependson, labType)}
              onClick={handleOpen}
              aria-label="stop"
            >
              <StopTwoToneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
            </Button>
          </span>
        </Tooltip>

    </div>
  );
}
